import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { HiOutlineLockClosed } from "react-icons/hi2";

import SettingsCard from "./SettingsCard";

import { changePassword } from "../../../../redux/features/settings/settingsSlice";

import "./SettingsForms.css";

export default function PasswordSettingsCard({ user }) {
  const dispatch = useDispatch();

  const { isChangingPassword } = useSelector((state) => state.settings);

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
  });

  const isCoreUser = user?.auth_provider === "core";

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    await dispatch(changePassword(formData)).unwrap();

    setFormData({
      currentPassword: "",
      newPassword: "",
    });
  };

  return (
    <SettingsCard
      icon={<HiOutlineLockClosed />}
      title="Wachtwoord"
      description="Beheer je wachtwoord."
    >
      {isCoreUser ? (
        <div className="settings-form__notice">
          Wachtwoord wordt beheerd via het centrale systeem.
        </div>
      ) : (
        <form className="settings-form" onSubmit={handleSubmit}>
          <div className="settings-form__group">
            <label>Huidig wachtwoord</label>
            <input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleChange}
              disabled={isChangingPassword}
              autoComplete="current-password"
            />
          </div>

          <div className="settings-form__group">
            <label>Nieuw wachtwoord</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              disabled={isChangingPassword}
              autoComplete="new-password"
            />
          </div>

          <button
            className="settings-form__submit"
            disabled={isChangingPassword}
          >
            {isChangingPassword ? "Wijzigen..." : "Wachtwoord wijzigen"}
          </button>
        </form>
      )}
    </SettingsCard>
  );
}
